import type { LoomComment } from '../../types';

export const isLoomComment = (entity: any): entity is LoomComment =>
	entity.__typename === 'LoomComment';

export const getLoomCommentLink = (comment: LoomComment): string | null => comment?.url ?? null;
